import { cardItems } from '@/mocks/homeData';

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl text-foreground-950">
            精选爆料
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            编辑精选的黑料深度报道，多角度还原事件真相
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {cardItems.slice(0, 6).map((item) => (
            <a
              key={item.id}
              href="#media"
              className="group block bg-background-50 border border-background-200/70 rounded-xl overflow-hidden hover:border-primary-300 transition-all duration-300 cursor-pointer"
            >
              <div className="relative aspect-[3/2] overflow-hidden">
                <img
                  src={item.cover}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 bg-primary-500 text-background-50 text-xs font-medium rounded-full whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="p-4 md:p-5">
                <div className="text-xs text-foreground-400 mb-2">{item.date}</div>
                <h3 className="text-sm md:text-base font-semibold text-foreground-800 line-clamp-2 group-hover:text-primary-600 transition-colors leading-snug">
                  {item.title}
                </h3>
                <p className="mt-2 text-xs md:text-sm text-foreground-500 line-clamp-2 leading-relaxed">
                  {item.excerpt}
                </p>
              </div>
            </a>
          ))}
        </div>

        {cardItems.length > 6 && (
          <div className="mt-6">
            <a
              key={cardItems[6].id}
              href="#media"
              className="group block bg-background-50 border border-background-200/70 rounded-xl overflow-hidden hover:border-primary-300 transition-all duration-300 cursor-pointer"
            >
              <div className="flex flex-col md:flex-row">
                <div className="md:w-[360px] flex-shrink-0">
                  <div className="relative aspect-[3/2] md:aspect-auto md:h-full overflow-hidden">
                    <img
                      src={cardItems[6].cover}
                      alt={cardItems[6].title}
                      className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                      loading="lazy"
                    />
                    <div className="absolute top-3 left-3">
                      <span className="px-2.5 py-1 bg-primary-500 text-background-50 text-xs font-medium rounded-full whitespace-nowrap">
                        {cardItems[6].tag}
                      </span>
                    </div>
                  </div>
                </div>
                <div className="flex-1 p-5 md:p-6 flex flex-col justify-center">
                  <div className="text-xs text-foreground-400 mb-2">{cardItems[6].date}</div>
                  <h3 className="text-lg md:text-xl font-semibold text-foreground-800 group-hover:text-primary-600 transition-colors">
                    {cardItems[6].title}
                  </h3>
                  <p className="mt-2 text-sm text-foreground-500 leading-relaxed">
                    {cardItems[6].excerpt}
                  </p>
                  <div className="mt-4 flex items-center gap-1 text-sm font-medium text-primary-500 group-hover:gap-2 transition-all">
                    <span>阅读全文</span>
                    <i className="ri-arrow-right-line" />
                  </div>
                </div>
              </div>
            </a>
          </div>
        )}
      </div>
    </section>
  );
}